var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      ref: "registrationForm",
      staticClass: "w-100",
      attrs: { autocomplete: "on", method: "post" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.validateRegistration()
        },
      },
    },
    [
      _c("div", { staticClass: "radio-btn__wrapper" }, [
        _c(
          "div",
          {
            staticClass: "radio-btn",
            class: { "radio-btn--checked": _vm.btnChecked === "b2c" },
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.btnChecked,
                  expression: "btnChecked",
                },
              ],
              attrs: {
                type: "radio",
                id: "b2c",
                name: "kundentyp",
                value: "b2c",
              },
              domProps: { checked: _vm._q(_vm.btnChecked, "b2c") },
              on: {
                change: function ($event) {
                  _vm.btnChecked = "b2c"
                },
              },
            }),
            _c(
              "label",
              { staticClass: "btn-registration-type", attrs: { for: "b2c" } },
              [
                _vm._v(
                  _vm._s(
                    _vm.$translate(
                      "ODElvirasBastelmaterial::Template.checkoutPrivate"
                    )
                  )
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "radio-btn",
            class: { "radio-btn--checked": _vm.btnChecked === "b2b" },
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.btnChecked,
                  expression: "btnChecked",
                },
              ],
              attrs: {
                type: "radio",
                id: "b2b",
                name: "kundentyp",
                value: "b2b",
              },
              domProps: { checked: _vm._q(_vm.btnChecked, "b2b") },
              on: {
                change: function ($event) {
                  _vm.btnChecked = "b2b"
                },
              },
            }),
            _c(
              "label",
              { staticClass: "btn-registration-type", attrs: { for: "b2b" } },
              [
                _vm._v(
                  _vm._s(
                    _vm.$translate(
                      "ODElvirasBastelmaterial::Template.checkoutB2b"
                    )
                  )
                ),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _vm.btnChecked == "b2c"
            ? _c("ul", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$translate("ODElvirasBastelmaterial::Template.b2cText")
                  ),
                },
              })
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12" }, [
          _vm.btnChecked == "b2b"
            ? _c("ul", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$translate("ODElvirasBastelmaterial::Template.b2bText")
                  ),
                },
              })
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-12" }, [
            _c(
              "div",
              { staticClass: "input-unit", attrs: { "data-validate": "mail" } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.username,
                      expression: "username",
                    },
                  ],
                  attrs: {
                    type: "email",
                    name: "email",
                    autocomplete: "email",
                    id: "email" + _vm._uid,
                    "data-autofocus": "",
                  },
                  domProps: { value: _vm.username },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.username = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "email" + _vm._uid } }, [
                  _vm._v(
                    _vm._s(_vm.$translate("Ceres::Template.regEmail")) + "*"
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          !_vm.guestMode
            ? _c("div", { staticClass: "col-sm-6" }, [
                _c(
                  "div",
                  {
                    ref: "passwordInput",
                    staticClass: "input-unit",
                    class: { "no-bottom media-xs-d": _vm.modalElement },
                    attrs: { "data-validate": "password" },
                  },
                  [
                    _c("popper", {
                      ref: "passwordHint",
                      attrs: { trigger: "focus", placement: "bottom" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "handle",
                            fn: function () {
                              return [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.password,
                                      expression: "password",
                                    },
                                  ],
                                  attrs: {
                                    type: "password",
                                    name: "password",
                                    autocomplete: "new-password",
                                    id: "new-password-" + _vm._uid,
                                  },
                                  domProps: { value: _vm.password },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.password = $event.target.value
                                    },
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("div", [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.regPasswordHintTitle"
                                        )
                                      ) +
                                      "\n                        "
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "content",
                            fn: function () {
                              return [
                                _c("ul", { staticClass: "pl-3" }, [
                                  _c("li", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.regPasswordHintLength"
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.regPasswordHintDigit"
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.regPasswordHintChar"
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        4086647824
                      ),
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      { attrs: { for: "new-password-" + _vm._uid } },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Ceres::Template.regPassword")
                          ) + "*"
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.guestMode
            ? _c("div", { staticClass: "col-sm-6 input-unit-group" }, [
                _c(
                  "div",
                  {
                    staticClass: "input-unit",
                    class: { "no-bottom": _vm.modalElement },
                    attrs: { "data-validate": "ref" },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.passwordRepeat,
                          expression: "passwordRepeat",
                        },
                      ],
                      attrs: {
                        type: "password",
                        name: "password-repeat",
                        autocomplete: "new-password",
                        id: "new-password-repeat-" + _vm._uid,
                        "data-validate-ref": "#new-password-" + _vm._uid,
                      },
                      domProps: { value: _vm.passwordRepeat },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.passwordRepeat = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      { attrs: { for: "new-password-repeat" + _vm._uid } },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Ceres::Template.regRepeatPassword")
                          ) + "*"
                        ),
                      ]
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.honeypot,
                expression: "honeypot",
              },
            ],
            staticClass: "honey",
            attrs: {
              type: "text",
              name: "username",
              autocomplete: "off",
              tabindex: "-1",
            },
            domProps: { value: _vm.honeypot },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.honeypot = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              !_vm.isSimpleRegistration
                ? _c("address-input-group", {
                    attrs: {
                      template: "#vue-address-input-group",
                      "address-type": "1",
                      value: _vm.billingAddress,
                      "optional-address-fields": _vm.shownFields,
                      "required-address-fields": _vm.requiredFields,
                      "default-salutation": _vm.defaultSalutation,
                      "btn-checked": _vm.btnChecked,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.setAddressDataField($event)
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "custom-address-fields",
                          fn: function () {
                            return [_vm._t("custom-address-fields")]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _vm.btnChecked === "b2b"
            ? [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "input-unit input-name-field" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.youAre,
                            expression: "youAre",
                          },
                        ],
                        staticClass: "custom-select",
                        attrs: { name: "youAre", id: "txt_youAre" },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.youAre = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "15" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "ODElvirasBastelmaterial::Template.elviraYouAreOption1"
                              )
                            ) + "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "16" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "ODElvirasBastelmaterial::Template.elviraYouAreOption2"
                              )
                            ) + "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "17" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "ODElvirasBastelmaterial::Template.elviraYouAreOption3"
                              )
                            ) + "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "18" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "ODElvirasBastelmaterial::Template.elviraYouAreOption4"
                              )
                            ) + "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "19" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "ODElvirasBastelmaterial::Template.elviraYouAreOption5"
                              )
                            ) + "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "20" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "ODElvirasBastelmaterial::Template.elviraYouAreOption6"
                              )
                            ) + "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "21" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "ODElvirasBastelmaterial::Template.elviraYouAreOption7"
                              )
                            ) + "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "22" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "ODElvirasBastelmaterial::Template.elviraYouAreOption8"
                              )
                            ) + "\n                        "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "txt_youAre" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "ODElvirasBastelmaterial::Template.elviraYouAre"
                          )
                        )
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "input-unit input-name-field" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.dachverband,
                          expression: "dachverband",
                        },
                      ],
                      attrs: {
                        type: "text",
                        name: "dachverband",
                        id: "txt_dachverband",
                      },
                      domProps: { value: _vm.dachverband },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.dachverband = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "txt_dachverband" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "ODElvirasBastelmaterial::Template.elviraDachverband"
                          )
                        )
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "input-unit input-name-field" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.referrer,
                            expression: "referrer",
                          },
                        ],
                        staticClass: "custom-select",
                        attrs: { name: "referrer", id: "txt_referrer" },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.referrer = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "10" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "ODElvirasBastelmaterial::Template.elviraReferrerOption1"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "11" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "ODElvirasBastelmaterial::Template.elviraReferrerOption2"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "12" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "ODElvirasBastelmaterial::Template.elviraReferrerOption3"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "13" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "ODElvirasBastelmaterial::Template.elviraReferrerOption4"
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "txt_referrer" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "ODElvirasBastelmaterial::Template.elviraReferrer"
                          )
                        )
                      ),
                    ]),
                  ]),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.enableConfirmingPrivacyPolicy
            ? _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("accept-privacy-policy-check", {
                    staticClass: "mt-3 mb-0",
                    attrs: { "show-error": _vm.privacyPolicyShowError },
                    on: {
                      input: function ($event) {
                        return _vm.privacyPolicyValueChanged($event)
                      },
                    },
                    model: {
                      value: _vm.privacyPolicyAccepted,
                      callback: function ($$v) {
                        _vm.privacyPolicyAccepted = $$v
                      },
                      expression: "privacyPolicyAccepted",
                    },
                  }),
                  _vm._v(" "),
                  _c("subscribe-newsletter-check", {
                    attrs: {
                      "email-folder": 1,
                      "hide-checkbox": false,
                      "custom-text":
                        "Ich möchte mich für den Elvira-Newsletter registrieren. Hiermit bestätige ich, dass ich die Datenschutzerklärung gelesen habe und in die Verarbeitung der angegebenen E-Mail-Adresse zum Zweck des Newsletterversands einwillige. Zudem willige ich in die Speicherung und Verarbeitung meiner Nutzungsdaten in der Empfängerstatistik des Newslettertools ein. Meine Einwilligung kann ich jederzeit widerrufen.",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "border-top mt-2 text-right" },
        [
          _vm._t("extend-overlay-buttons"),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-appearance btn-primary btn-medium mt-3",
              class: _vm.buttonSizeClass,
              attrs: { disabled: _vm.isDisabled },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$translate("Ceres::Template.regRegister")) +
                  "\n            "
              ),
              _c("icon", {
                staticClass: "default-float",
                attrs: { icon: "user-plus", loading: _vm.isDisabled },
              }),
            ],
            1
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "hr-text" }, [
      _c("span", [_vm._v("Ihre Registrierungsdaten")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "hr-text" }, [
      _c("span", [_vm._v("Ihre Rechnungsanschrift")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "hr-text" }, [
      _c("span", [
        _vm._v(
          "Weitere freiwillige Angaben, die uns bei der Bestellabwicklung unterstützen"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }